/**
 * Logs a formated error message in console
 * @param message Error message to log
 */
export function logError(message: string) {
  return console.error(`Vattenfall Elements: ${message}`);
}
